import { produce } from "immer";
import { ActionType, createReducer } from "typesafe-actions";

import { PROCEDURE_INDEX_DEFAULT_LIMIT, PROCEDURE_INDEX_LOAD_ERROR } from "../constants";
import { ProcedureIndexDisplayStatus, ProcedureIndexStateType, ProcedureIndexStatusFilter } from "../interfaces";
import * as actions from "./actions";

type Action = ActionType<typeof actions>;

const defaultFilter: ProcedureIndexStatusFilter = {
  page: 0,
  limit: PROCEDURE_INDEX_DEFAULT_LIMIT,
};

const emptyCounts = () => ({
  [ProcedureIndexDisplayStatus.INDEXED]: 0,
  [ProcedureIndexDisplayStatus.SKIPPED]: 0,
  [ProcedureIndexDisplayStatus.FAILED]: 0,
  [ProcedureIndexDisplayStatus.REMOVED]: 0,
  [ProcedureIndexDisplayStatus.NEVER_INDEXED]: 0,
  [ProcedureIndexDisplayStatus.NOT_APPLICABLE]: 0,
});

export const initialState: ProcedureIndexStateType = {
  rows: [],
  total: 0,
  counts: emptyCounts(),
  filter: { ...defaultFilter },
  loadError: null,
};

const reducer = createReducer<ProcedureIndexStateType, Action>(initialState)
  .handleAction(actions.getProcedureIndexStatus.request, (state) =>
    produce(state, (nextState) => {
      nextState.loadError = null;
    }),
  )
  // Always REPLACES, matching the eval run list's own paginated-table reasoning: page 2 must replace
  // page 1's rows, not grow the array.
  .handleAction(actions.getProcedureIndexStatus.success, (state, action) =>
    produce(state, (nextState) => {
      nextState.rows = [...action.payload.results];
      nextState.total = action.payload.total;
      nextState.counts = action.payload.counts;
      nextState.loadError = null;
    }),
  )
  .handleAction(actions.getProcedureIndexStatus.failure, (state) =>
    produce(state, (nextState) => {
      nextState.loadError = PROCEDURE_INDEX_LOAD_ERROR;
    }),
  )
  .handleAction(actions.setFilter, (state, action) =>
    produce(state, (nextState) => {
      nextState.filter = action.payload || { ...defaultFilter };
    }),
  )
  .handleAction(actions.clear, (state) =>
    produce(state, (nextState) => {
      nextState.rows = [];
      nextState.total = 0;
      nextState.counts = emptyCounts();
    }),
  );

export { reducer as ProcedureIndexReducer };
